<template>
    <div class="table-responsive mb-0">
        <table class="table table-sm bordered-header">
            <thead>
                <tr>
                    <th>Personel</th>
                    <th>Hatalar</th>
                </tr>
            </thead>
            <tbody>
                <template v-for="(emp,i) in ($safe(value,'EmployeeErrors') || [])">
                    <template v-for="(e,ii) in ($safe(emp,'Errors') || [])">
                        <tr>
                            <td class="text-nowrap border-right align-top" v-if="ii == 0" :rowspan="($safe(emp,'Errors') || []).length">{{ $safe(emp,'EmployeeFullName') || '-' }}</td>
                            <td class="text-nowrap">{{ e }}</td>
                        </tr>
                    </template>
                </template>
            </tbody>
        </table>
    </div>
</template>

<script>
export default{
    props:{
        value:Object
    }
}
</script>